import { tv } from 'tailwind-variants'

export const spinner = tv({
  slots: {
    container: 'relative flex flex-1 items-center justify-center',
    subContainer: 'flex h-8 w-8 items-center justify-center',
    loader: 'h-8 w-8',
  },
  variants: {
    size: {
      small: {
        subContainer: 'h-5 w-5',
        loader: 'h-5 w-5',
      },
      large: {
        subContainer: 'h-8 w-8',
        loader: 'h-8 w-8',
      },
    },
    isFullScreen: {
      true: {
        container: 'absolute bottom-0 left-0 right-0 top-0',
      },
    },
  },
  defaultVariants: {
    size: 'large',
  },
})
